import ApiService from './ApiService'

export default class ChargeService {
    apiService

    constructor(token) {
        this.apiService = new ApiService(process.env.VUE_APP_MTN_API)
        this.apiService.setAccessToken(token)
    }

    async status(id) {
        return this.apiService
            .get('/status', {
                transactionId: id,
            })
            .then((response) => response)
    }

    async chargeWithUuid({ uuid, plan }) {
        return this.apiService
            .post('/purchase', {
                uuid,
                packageId: plan,
            })
            .then((response) => response)
    }

    async chargeWithMsisdn({ userId, msisdn, plan, uvid }) {
        return this.apiService
            .post('/purchase', {
                userId,
                msisdn,
                packageId: plan,
                uvid,
            })
            .then((response) => response)
    }

    async cancel({ subscriptionId, msisdn }) {
        return this.apiService
            .post('/cancel', {
                subscriptionId,
                msisdn,
            })
            .then((response) => response)
    }

    async check({ transactionId }) {
        return this.apiService
            .get('/status', {
                transactionId,
            })
            .then((response) => response)
    }
}
